import { useTranslation } from 'react-i18next';

import SellableLabel from '../../../../common/Common/SellableLabel';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

export interface RegistrationInfoProps {
  registration: {
    assigned: boolean;
    full_name?: string | null;
    invited_email?: string | null;
    participant: {
      email: string;
    };
    ticket: {
      title: string;
    };
    purchase: {
      active: boolean;
    };
    ticket_number?: string;
    sequence: number;
    created_at?: string;
  };
}

const RegistrationInfo = ({ registration }: RegistrationInfoProps) => {
  const { t } = useTranslation();
  const { formatDate, parseDate } = useLocale();

  const isDisabled = !registration.purchase.active;

  return (
    <UI.Info>
      <UI.FormGrid sc={{ columns: '1fr fit-content(150px)', gutter: 0.5, alignVertical: 'center' }}>
        <UI.Div>
          <UI.Div sc={{ strong: true, small: true }}>
            <UI.Span sc={{ muted: !registration.assigned || isDisabled, deleted: isDisabled, mr: 1 }}>
              {registration.assigned
                ? registration.full_name
                : (registration.invited_email || registration.participant.email)}
            </UI.Span>
            {' '}
            <UI.Span sc={{ fontWeight: 400, muted: true }}>
              {registration.assigned ? registration.participant.email : (registration.invited_email
                ? t('invited')
                : t('not_assigned_yet'))}
            </UI.Span>
          </UI.Div>
          <UI.FlexContainer sc={{ wrap: 'wrap' }}>
            <SellableLabel sc={{ mt: 0.5, mr: 1 }}>
              <UI.Icon>
                <UI.Icons.Ticket />
              </UI.Icon>
              {' '}
              {registration.ticket.title}
            </SellableLabel>
            {registration.ticket_number && (
              <UI.Label sc={{ small: true, mt: 0.5 }}>
                <UI.Icon>
                  <UI.Icons.StartFinish />
                </UI.Icon>
                {' '}
                {registration.ticket_number}
              </UI.Label>
            )}
          </UI.FlexContainer>
        </UI.Div>
        <UI.Div sc={{ small: true, textAlign: 'right', mt: 0.5 }}>
          <UI.Div sc={{ fontWeight: 500 }}>
            ATL
            {registration.sequence}
          </UI.Div>
          <UI.Div sc={{ mt: 0.5, muted: true }}>
            {formatDate(
              parseDate(registration.created_at, { timezone: 'UTC' }),
              { format: 'display_compact_date' },
            )}
          </UI.Div>
        </UI.Div>
      </UI.FormGrid>
    </UI.Info>
  );
};

export default RegistrationInfo;
